import { translations as translationsUploadFile } from "../../../../components/single-registry/upload/UploadFileConclusion/constants";

export const translations = {
  ...translationsUploadFile,
  title: {
    id: "vehicle.single.registry.upload.uploadFileConclusionWidget.title",
    defaultMessage: "All set!",
  },
  subtitle: {
    id: "vehicle.single.registry.upload.uploadFileConclusionWidget.subtitle",
    defaultMessage:
      "Now just wait for the vehicles to sync with the selected platforms.",
  },
  followProgress: {
    id: "vehicle.single.registry.upload.uploadFileConclusionWidget.followProgress",
    defaultMessage: "Track the progress {link}.",
  },
};
